export const currentRole = (role) => {
    console.log("Current role", role)
    return {
        type: "ROLE_SELECTED",
        payload: role,
    };
};